const FONTS_REGISTRY = {

    "deutsch_gothicnormal": {
        "sources": `
        url('/app/fonts/deutch_gothic/woff/Deutsch-webfont.woff') format('woff')
        `,
        "fontWeight": "normal",
        "fontStyle": "normal",
    },
    "roboto_light": {
        "sources": `
        url('/public/fonts/roboto/woff2/roboto-light-webfont.woff2') format('woff2'),
        url('/public/fonts/roboto/woff/roboto-light-webfont.woff') format('woff'),
        url('/public/fonts/roboto/ttf/roboto-light-webfont.ttf') format('truetype')
        `,
        "fontWeight": "normal",
        "fontStyle": "normal",
    },
    
    "interlight": {
        "sources": `
        url('/public/fonts/inter/Inter-Light.woff2") format("woff2"),
        url('/public/fonts/inter/Inter-Light.ttf") format("truetype")
        `,
        "fontWeight": "normal",
        "fontStyle": "normal",
    },
    "intermedium": {
        "sources": `
        url('/public/fonts/inter/Inter-Medium.woff2") format("woff2"),
        url('/public/fonts/inter/Inter-Medium.ttf") format("truetype")
        `,
        "fontWeight": "normal",
        "fontStyle": "normal",
    },
    "interregular": {
        "sources": `
        url('/public/fonts/inter/Inter-Regular.woff2") format("woff2"),
        url('/public/fonts/inter/Inter-Regular.ttf") format("truetype")
        `,
        "fontWeight": "normal",
        "fontStyle": "normal",
    },
};


export default FONTS_REGISTRY;